import { render, staticRenderFns } from "./assest.vue?vue&type=template&id=2d755fc1&scoped=true"
import script from "./assest.vue?vue&type=script&lang=js"
export * from "./assest.vue?vue&type=script&lang=js"
import style0 from "./assest.vue?vue&type=style&index=0&id=2d755fc1&prod&lang=scss&scoped=true"
import style1 from "./assest.vue?vue&type=style&index=1&id=2d755fc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d755fc1",
  null
  
)

export default component.exports